import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import axios from 'axios';

const reduceCb = (acc, [key, value]) => {
  const hasStrVal = typeof value === 'string' && value.trim();
  const hasArrVal = Array.isArray(value) && value.length;
  const hasBooleanVal = typeof value === 'boolean';

  if (hasStrVal) {
    acc[key] = value.trim();
  } else if (hasArrVal || hasBooleanVal) {
    acc[key] = value;
  }

  return acc;
};

const filterUndefined = (props) =>
  !props ? {} : Object.entries(props).reduce(reduceCb, {});

const getInformations = (
  params,
  errMsg = 'При загрузке списка информирований произошла ошибка'
) => {
  const source = axios.CancelToken.source();

  const promise = request.get(
    '/Information',
    params,
    errMsg,
    undefined,
    undefined,
    'comma',
    { cancelToken: source.token }
  );

  promise.cancel = () => {
    source.cancel();
  };

  return promise;
};

export const createInformationsKeys = (params) => [
  'informations',
  filterUndefined(params),
];
export const createInfoByIdKey = (infoId) => ['infoById', infoId];

const useInformations = (params, options) => {
  return useQuery(
    createInformationsKeys(params),
    () => getInformations(filterUndefined(params)),
    options
  );
};

export const fetchInfoById = async ({ infoId, queryClient }) =>
  await queryClient.fetchQuery(createInfoByIdKey(infoId), () =>
    getInformations(
      { search: infoId },
      'Не удалось загрузить обновленное информирование'
    )
  );

export default useInformations;
